<template>
    <ProgressBar
        :value="value"
        :maxValue="row.NumContestants"
        type="dynamic"
    />
</template>

<script lang="ts" setup>
import { ProgressBar } from '@/components';
import type { RaceControlItem } from '@/objects/RaceControlItem';

defineProps<{
    /**
     * The value to display.
     */
    value: number;

    /**
     * The row
     */
    row: RaceControlItem;
}>();
</script>
